export enum ResourceType {
    Any = -1,
    Account,
    Contact,
    Deal,
    Job,
    JobBooking,
    Package,
    Peripheral,
    Product,
    ProductGroup,
    Sim,
    Site,
    Unit,
    Vehicle,
    Ticket,
    Stock,
    Engineer,
    SoftwareLog,
    Driver,
    Trailer,
    VerilocationUser,
    Announcement,
    Plot,
    User,
    DriverDecisionSupport,
    GeocodedAddress,
    Geofence,
    Group,
    Journey,
    Message,
    OutboundQueue,
    RfidData,
    DigiDl,
    AlertRecord,
    ReportSchedule,
    Log,
    Test,
    MaintenanceType,
    StirlingJob,
    DigiDlPacket,
    EngineerCommission,
    InputType,
}

export enum ResourceAllocation {
    All,
    Vehicle,
    Driver,
    Geofence
}
